export const FETCHING_CLIENT_DATA = 'FETCHING_CLIENT_DATA';
export const RECEIVE_CLIENT_DATA = 'RECEIVE_CLIENT_DATA';
export const FETCH_CLIENT_ERROR = 'FETCH_CLIENT_ERROR';
